import smartphonePin from './images/smartphonePin.svg';
import multipleDevices from './images/multipleDevices.svg';
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import lion from "./images/lion.svg"
import lionFill from "./images/lionFill.svg"
import smsSvg from "./images/sms.svg"
import appSvg from "./images/app.svg"
import itsMeSvg from "./images/itsme.svg"
import cardReaderSvg from "./images/cardReader.svg"
import etcSvg from "./images/etc.svg"
import questions from "./images/questions.svg"
import { ITheme } from 'pu-crossproduct-components/build/themes';
import { NavigationDrawer, NavigationDrawerColors } from "pu-crossproduct-components/build/components/Organisms/Navigation/NavigationDrawer";
import { FullPageOverlay } from "pu-crossproduct-components/build/components/Organisms/FullPageOverlay";
import { Item } from 'pu-crossproduct-components/build/components/Molecules/Navigation/NavigationElements/Item';
import { GridContainer, GridItem, GridRow } from 'pu-crossproduct-components/build/components/Atoms/Grid';
import { Body2, DisplayH1 } from 'pu-crossproduct-components/build/components/Atoms/Type';
import { Link, LinkColors } from 'pu-crossproduct-components/build/components/Molecules/Navigation/Link';
import { Button, Emphasis } from 'pu-crossproduct-components/build/components/Molecules/Navigation/Button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { table } from 'node:console';


interface IProps {
    open?: boolean;
}

interface IDispatch {
    onClose?: () => void;
}

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export const InformatExplanation: React.FC<IProps & IDispatch> = props => {

    const { t } = useTranslation();
    const theme = React.useContext<ITheme>(ThemeContext);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const history = useHistory();
    const [width, height] = useWindowSize();
    const stickyNavigationDrawer = width >= 1440;

    const handleClose = () => props.onClose && props.onClose();

    useEffect(() => {
        const handleScroll = () => {

            window.location.hash = '_';

            let scrollIndex = -1;

            if (stickyNavigationDrawer) {
                const currentScrollY_Top = document.getElementById("explanationGrid")?.scrollTop ?? 0;
                const currentScrollY_Bottom = currentScrollY_Top + window.innerHeight;
                const overlayScrollHeight = document.getElementById("explanationGrid")?.scrollHeight ?? 0;

                let extraBeveiligingTop = document.getElementById("extraBeveiliging")?.getBoundingClientRect()?.top ?? 0;
                let hoeWerktHetTop = document.getElementById("hoeWerktHet")?.getBoundingClientRect()?.top ?? 0;
                let vlaamseOverheidTop = document.getElementById("vlaamseOverheid")?.getBoundingClientRect()?.top ?? 0;
                let mogelijkhedenTop = document.getElementById("mogelijkheden")?.getBoundingClientRect()?.top ?? 0;
                let hulpTop = document.getElementById("hulp")?.getBoundingClientRect()?.top ?? 0;

                if (extraBeveiligingTop < 100 || currentScrollY_Top < extraBeveiligingTop) {
                    scrollIndex = 0;
                    if (hoeWerktHetTop < 100) {
                        scrollIndex = 1;
                        if (vlaamseOverheidTop < 100) {
                            scrollIndex = 2;
                            if (mogelijkhedenTop < 100) {
                                scrollIndex = 3;
                                if (hulpTop < 100 || currentScrollY_Bottom + 100 > overlayScrollHeight) {
                                    scrollIndex = 4;
                                }
                            }
                        }
                    }
                }
            }

            setSelectedIndex(scrollIndex);

        };

        document.getElementById("explanationGrid")?.addEventListener("scroll", handleScroll, { passive: true });
        return () => document.getElementById("explanationGrid")?.removeEventListener("scroll", handleScroll);

    });


    return (
        <FullPageOverlay open={props.open ?? false} onClose={handleClose} id="explanationGrid">
            <div style={{ position: stickyNavigationDrawer ? 'absolute' : 'relative', zIndex: 1, height: '100%', width: stickyNavigationDrawer ? '15%' : '', marginTop: stickyNavigationDrawer ? '' : '-75px' }}>
                <NavigationDrawer open={true} color={NavigationDrawerColors.Light} stickyOverlay={stickyNavigationDrawer}  >
                    <Item selected={selectedIndex == 0} label={t("twoFactorInformatInfoPageExtraSecurityNavLabel")} onClick={() => window.location.hash = 'extraBeveiliging'} />
                    <Item selected={selectedIndex == 1} label={t("twoFactorInformatInfoPageHowDoesItWorkNavLabel")} onClick={() => window.location.hash = 'hoeWerktHet'} />
                    <Item selected={selectedIndex == 2} label={t("twoFactorInformatInfoPageFlamishGovernmentNavLabel")} onClick={() => window.location.hash = 'vlaamseOverheid'} />
                    <Item selected={selectedIndex == 3} label={t("twoFactorInformatInfoPageWhatDoYouNeedNavLabel")} onClick={() => window.location.hash = 'mogelijkheden'} />
                    <Item selected={selectedIndex == 4} label={t("twoFactorInformatInfoPageNeedHelpOrQuestionsNavLabel")} onClick={() => window.location.hash = 'hulp'} />
                </NavigationDrawer>
            </div>

            <div style={{ marginBottom: '64px', marginTop: stickyNavigationDrawer ? '-100px' : '', height: '100%' }} id='containerWrapper'>
                <GridContainer>
                    <GridRow id="extraBeveiliging" style={{ background: theme.base.colors.support.background.background50 }}>
                        <GridItem col={0} laptopL={2} />
                        <GridItem col={12} laptop={6} laptopL={5}  >
                            <div style={{ width: '100%', height: '100%', padding: '48px 64px 57px 32px', boxSizing: 'border-box' }}>
                                <DisplayH1>{t("twoFactorInformatInfoPageExtraSecutityTitle")}</DisplayH1>
                                <Body2>
                                    {t("twoFactorInformatInfoPageExtraSecutityText1")} </Body2>
                                <Body2>
                                    {t("twoFactorInformatInfoPageExtraSecutityText2")} </Body2>
                            </div>
                        </GridItem>
                        <GridItem col={0} laptop={6} laptopL={5} style={{ alignSelf: "center", boxSizing: 'border-box' }}  >
                            <img src={smartphonePin} style={{ width: '80%', height: 'auto', maxHeight: '524px', objectFit: 'contain', display: "block", margin: 'auto' }} />
                        </GridItem>
                    </GridRow>
                    <GridRow id="hoeWerktHet" style={{ background: "white" }} >
                        <GridItem col={0} laptopL={2} />
                        <GridItem col={0} laptop={6} laptopL={5}  >
                            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                                <img src={multipleDevices} style={{ objectFit: 'contain', display: "block", maxHeight: '600px', position: 'absolute', bottom: '0px', right: '24px' }} />
                            </div>

                        </GridItem>
                        <GridItem col={12} laptop={6} laptopL={5} style={{ border: '1px solid white', boxSizing: 'border-box' }} >
                            <div style={{ background: theme.base.colors.primary.primary700, color: theme.base.colors.grey.white, padding: '48px 64px 57px 32px' }}>
                                <DisplayH1 style={{ color: theme.base.colors.grey.white }}>
                                    {t("twoFactorInformatInfoPageHowDoesItWorkTitle")} </DisplayH1>
                                <ol style={{ WebkitPaddingStart: '18px' }}>
                                    <li style={{ paddingLeft: '16px' }}>
                                        <Body2 style={{}}>
                                            {t("twoFactorInformatInfoPageHowDoesItWorkLI1_1")}<br />{t("twoFactorInformatInfoPageHowDoesItWorkLI1_2")}
                                        </Body2>
                                    </li>
                                    <li style={{ paddingLeft: '16px' }}>
                                        <Body2 style={{}}>
                                            {t("twoFactorInformatInfoPageHowDoesItWorkLI2_1")}<br />{t("twoFactorInformatInfoPageHowDoesItWorkLI2_2")} </Body2>
                                    </li>
                                </ol>
                                <Body2 style={{ color: theme.base.colors.grey.white }}>
                                    {t("twoFactorInformatInfoPageHowDoesItWorkText_1")} <br />{t("twoFactorInformatInfoPageHowDoesItWorkText_2")} </Body2>
                            </div>
                        </GridItem>
                    </GridRow>
                    <GridRow id="vlaamseOverheid" style={{ background: theme.base.colors.support.background.background50 }}>
                        <GridItem col={0} laptopL={2} />
                        <GridItem col={12} laptop={6} laptopL={5}  >
                            <div style={{ width: '100%', height: '100%', padding: '48px 64px 57px 32px' }}>
                                <DisplayH1>{t("twoFactorInformatInfoPageFlamishGovernmentTitle")} </DisplayH1>
                                <Body2>
                                    {t("twoFactorInformatInfoPageFlamishGovernmentText1")} </Body2>
                                <Body2>
                                    {t("twoFactorInformatInfoPageFlamishGovernmentText2")} </Body2>
                            </div>
                        </GridItem>
                        <GridItem col={0} laptop={6} laptopL={5}   >
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <div style={{ float: 'right', width: '50%', height: '100%', direction: 'rtl' }}>
                                    <img src={lionFill} style={{ position: 'absolute', height: '100%', right: '0px' }} />
                                    <img src={lion} style={{ position: 'absolute', height: '70%', right: '200px', top: '15%' }} />

                                </div>
                            </div>
                        </GridItem>
                    </GridRow>
                    <GridRow id="mogelijkheden" style={{ paddingTop: '20px', background: "white" }} >
                        <GridItem col={0} laptopL={2} style={{ background: theme.base.colors.primary.primary700 }} />
                        <GridItem col={0} laptop={6} laptopL={5}  >
                            <div style={{ height: '100%', background: theme.base.colors.primary.primary700 }}>
                                <table style={{ width: '100%', height: '200px', position: 'relative', top: 'calc(50% - 150px)', textAlign: 'center', paddingLeft: '35px', paddingRight: '35px' }}>
                                    <tr >
                                        <td><img src={smsSvg} /></td>
                                        <td><img src={appSvg} /></td>
                                        <td><img src={itsMeSvg} /></td>
                                    </tr>
                                    <tr>
                                        <td><img src={cardReaderSvg} /></td>
                                        <td><img src={etcSvg} /></td>
                                    </tr>
                                </table>
                            </div>
                        </GridItem>
                        <GridItem col={12} laptop={6} laptopL={5}  >
                            <div style={{ padding: '48px 64px 57px 32px' }}>
                                <DisplayH1 >
                                    {t("twoFactorInformatInfoPageWhatDoYouNeedTitle")} </DisplayH1>
                                <Body2 style={{}}>
                                    {t("twoFactorInformatInfoPageWhatDoYouNeedText1")} </Body2>
                                <Body2 style={{}}>
                                    {t("twoFactorInformatInfoPageWhatDoYouNeedText2")}</Body2>
                                <Body2 style={{}}>
                                    {t("twoFactorInformatInfoPageWhatDoYouNeedText3")} <Link color={LinkColors.type} href="http://www.vlaanderen.be">vlaanderen.be</Link></Body2>
                            </div>
                        </GridItem>
                    </GridRow>
                    <GridRow id="hulp" style={{ background: theme.base.colors.support.background.background50, paddingTop: '20px' }}>
                        <GridItem col={0} laptopL={2} />
                        <GridItem col={12} laptop={6} laptopL={5}  >
                            <div style={{ width: '100%', height: '100%', padding: '48px 64px 57px 32px' }}>
                                <DisplayH1>{t("twoFactorInformatInfoPageNeedHelpOrQuestionsTitle")}
                                </DisplayH1>
                                <div style={{}}>
                                    <Body2 style={{}}>
                                        {t("twoFactorInformatInfoPageNeedHelpOrQuestionsText1")} </Body2>
                                    <Body2 style={{}}>
                                        {t("twoFactorInformatInfoPageNeedHelpOrQuestionsText2")} </Body2>
                                    <Body2 style={{}}>
                                        {t("twoFactorInformatInfoPageNeedHelpOrQuestionsText3")}</Body2>
                                </div>
                                <div style={{ marginTop: '73px' }}>
                                    <div style={{ float: 'left' }}>
                                        < Button onClick={handleClose} > {t("twoFactorInformatInfoPageInfoPageButtonOk")} </Button>
                                    </div>
                                    <div style={{ float: 'left', marginLeft: '25px' }}>
                                        <Button emphasis={Emphasis.medium} onClick={() => { window.open('https://www.vlaanderen.be/uw-overheid/werking-en-structuur/hoe-werkt-de-vlaamse-overheid/informatie-en-communicatie/aanmelden', '_blank', '') }}>{t("twoFactorInformatInfoPageInfoPageButtonNeedHelp")}</Button>
                                    </div>
                                </div>
                            </div>
                        </GridItem>
                        <GridItem col={0} laptop={6} laptopL={5}  >
                            <img src={questions} style={{}} />
                        </GridItem>
                    </GridRow>
                </GridContainer >
            </div >
        </FullPageOverlay >
    )
}
